.drawerContainer {
  background-color: white;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  justify-content: flex-start;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.calendarOverlay {
  position: absolute;
  right: 24px;
  height: 290px;
  width: 370px;
}

.calenderTooltip {
  background-color: white;
  border-radius: 16px;
  border: 1px solid #e2e2e2;
  position: absolute;
  right: 24px;
  top: 60px;
  width: min-content;
  z-index: 1;

  .calendarContainer {
    justify-content: center;
  }
}

.drawerCalenderContainer {
  flex: 1;
}

.show {
  animation: appear 0.5s forwards;
}

.hide {
  animation: disappear 0.5s forwards;
}

@media (--mobile-viewport) {
  :root {
    --dayIcn-font: var(--mobile-dayIcn-font);
    --dateIcn-font: var(--mobile-dateIcn-font);

    --dayIcn-font-size: var(--mobile-dayIcn-font-size);
    --dateIcn-font-size: var(--mobile-dateIcn-font-size);
  }

  .show {
    animation: slideUp 0.5s forwards;
  }

  .hide {
    animation: slideDown 0.5s forwards;
  }
}

@keyframes appear {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes disappear {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes slideUp {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slideDown {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
}
